import { DashboardChartData } from "./dashboard-chart-data";
import { DashboardItemType } from "./dashboard-item";

export class DashboardRevenueNowCompareData extends DashboardChartData {
	public hideLastMonth:boolean = false;
	public toShowAdditionalBookYears:number = 0;

	public constructor(data?:any, type?:DashboardItemType) {
		super(data, type);
		if (!data) return;
		this.hideLastMonth = data.hideLastMonth == "true";
		if (data.toShowAdditionalBookYears) {
			this.toShowAdditionalBookYears = parseInt(data.toShowAdditionalBookYears);
			if (Number.isNaN(this.toShowAdditionalBookYears)) {
				this.toShowAdditionalBookYears = 0;
			}
		}
	}

	getJSON():any{
		return {
			...super.getJSON(),
			hideLastMonth: this.hideLastMonth ? "true" : "false",
			toShowAdditionalBookYears: `${this.toShowAdditionalBookYears}`
		};
	}
}